import { useTranslation } from 'react-i18next'

import Button from '../../Button'

import SaveAsTemplateIcon from '../../../icons/template.svg'

function FilterBarSaveTemplateButton({
  canViewFilterTemplate,
  isSkeleton,
  onSaveTemplate,
}) {
  const { t } = useTranslation()

  return canViewFilterTemplate ? (
    <Button.Text
      isGreySecondary
      isHovered
      beforeIconProps={{ Icon: SaveAsTemplateIcon }}
      isSkeleton={isSkeleton}
      text={t('Table.SaveAsTemplateBtnKey')}
      onClick={onSaveTemplate}
    />
  ) : null
}

export default FilterBarSaveTemplateButton
